import type { AuthenticationResultType } from "@aws-sdk/client-cognito-identity-provider";

function validateCompleteAuthResult(
	result: AuthenticationResultType | undefined,
	defaultRefreshToken?: string,
) {
	if (!result) {
		return undefined;
	}

	const { IdToken, AccessToken, RefreshToken } = result;
	if (!IdToken || !AccessToken) {
		return undefined;
	}

	const newRefreshToken = RefreshToken ?? defaultRefreshToken;
	if (!newRefreshToken) {
		return undefined;
	}

	return {
		...result,
		IdToken,
		AccessToken,
		RefreshToken: newRefreshToken,
	};
}

export default validateCompleteAuthResult;
